/**
 * @generated SignedSource<<f776f6c3eea0f56a6c9304b5300135fa>>
 * @relayHash 7e7e86c50393bd91ccd31140eb439adb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b9bcae1436f9202c13d56dc45389fd2497c967083f8c60073ee6be35e8a9b328

import type { ConcreteRequest } from 'relay-runtime';
export type ApprovalsContextResolveApprovalAgentMutation$variables = {
  cloudId: string;
};
export type ApprovalsContextResolveApprovalAgentMutation$data = {
  readonly confluence_resolveApprovalAgent: {
    readonly agent: {
      readonly id: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }>;
    readonly success: boolean;
  } | null | undefined;
};
export type ApprovalsContextResolveApprovalAgentMutation = {
  response: ApprovalsContextResolveApprovalAgentMutation$data;
  variables: ApprovalsContextResolveApprovalAgentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceApprovalAgentPayload",
    "kind": "LinkedField",
    "name": "confluence_resolveApprovalAgent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "ConfluenceApprovalAgent",
        "kind": "LinkedField",
        "name": "agent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ApprovalsContextResolveApprovalAgentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ApprovalsContextResolveApprovalAgentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7e7e86c50393bd91ccd31140eb439adb",
    "id": "b9bcae1436f9202c13d56dc45389fd2497c967083f8c60073ee6be35e8a9b328",
    "metadata": {},
    "name": "ApprovalsContextResolveApprovalAgentMutation",
    "operationKind": "mutation",
    "text": "mutation ApprovalsContextResolveApprovalAgentMutation($cloudId:ID!){confluence_resolveApprovalAgent(cloudId:$cloudId){success,agent{id},errors{message}}}"
  }
};
})();

(node as any).hash = "e4cb35491d152f5cba04815adf8e599d";

export default node;
